module.exports = __webpack_public_path__ + "media/images/douche-cbfb8bf347b563c439628a6daa696b47.svg";